import { useTranslation } from 'next-i18next';
import React from 'react';
import { track } from '@hotelplan/libs.tracking-events';
import { FdrImage } from '@hotelplan/supergraph-api';
import { EShareType } from 'components/domain/fdr-share-overlay/fdr-share-overlay.types';
import FdrShareSiteToolPdf from 'components/domain/fdr-site-tool/fdr-share-site-tool-pdf';

type TProps = {
  title: string;
  hero: FdrImage;
};

enum EEvents {
  OPEN = 'open pdf popup',
  CLOSE = 'close pdf popup',
  SHARE = 'share',
}

function getPriceTypeInfo(type: string) {
  return type === 'WITH_PRICES' ? 'mit ab Preis' : 'ohne ab Preise';
}

function getShareTypeInfo(type: string) {
  switch (type) {
    case 'Link kopieren':
      return type;
    case 'mail':
      return `Teilen per Mail`;
    case 'whatsapp':
      return `Teilen per Whatsapp`;
    case 'Download':
      return type;
  }
}

const trackPdfActions = (action: string, label: string, language: string) => {
  track({
    event: `pdf`,
    action,
    label,
    category: undefined,
    component: `pdf-popup`,
    position: undefined,
    language,
    _clear: true,
  });
};

const trackPdfShare = (label: string, category: string, language: string) => {
  track({
    event: `pdf`,
    action: EEvents.SHARE,
    label: getShareTypeInfo(label),
    category: getPriceTypeInfo(category),
    component: `pdf-popup`,
    position: undefined,
    language,
    _clear: true,
  });
};

const trackFns = {
  trackOpen: (language: string) =>
    trackPdfActions(EEvents.OPEN, `PDF herunterladen`, language),
  trackClose: (language: string) =>
    trackPdfActions(EEvents.CLOSE, `Schliessen`, language),
  trackShare: (target: string, category: string, language: string) =>
    trackPdfShare(target, category, language),
};

const SharePdf: React.FC<TProps> = ({ title, hero }: TProps) => {
  const [t] = useTranslation('common');

  return (
    <FdrShareSiteToolPdf
      pageTitle={title}
      image={hero}
      overlayTitle={t('share.overlay.pdf')}
      icon="print-pdf"
      iconText={t('common:page.pdf.tooltip')}
      whiteList={[EShareType.MAIL, EShareType.WHATSAPP]}
      trackFns={trackFns}
    />
  );
};

export default SharePdf;
